<template>
  <div class="tpe-section mt-2">
    <a-divider class="tpe-divider">
      <span class="divider-text">{{
        $t("recette.saisirInfoTPE") || "Saisir les informations TPE"
      }}</span>
    </a-divider>
    <div class="tpe-fields-row">
      <div class="tpe-field">
        <label>{{ $t("decaissement.caisseBank") }}</label>
        <a-select
          :loading="loadingCaisses"
          :value="tpeData.caisseBank"
          :placeholder="$t('decaissement.validation.selectCaisse')"
          size="small"
          style="width: 100%"
          :class="{ 'input-error': isFieldInvalid('caisseBank') }"
          @change="(value) => emitTpeData('caisseBank', value)"
        >
          <a-select-option
            v-for="caisse in caisseBanque"
            :key="caisse._id"
            :value="caisse._id"
          >
            {{ caisse.name + " (" + caisse.reference + ")" }}
          </a-select-option>
        </a-select>
      </div>
      <div class="tpe-field">
        <label>ID Transaction TPE</label>
        <a-input
          :value="tpeData.transactionId"
          placeholder="ID de la transaction TPE"
          size="small"
          :class="{ 'input-error': isFieldInvalid('transactionId') }"
          @input="(e) => emitTpeData('transactionId', e.target.value)"
        />
      </div>
      <div class="tpe-field">
        <label>Montant TPE</label>
        <a-input-number
          :value="tpeData.montant"
          placeholder="Montant TPE"
          size="small"
          :min="0"
          style="width: 100%"
          :class="{ 'input-error': isFieldInvalid('montant') }"
          @change="(value) => emitTpeData('montant', value)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from "@/services/axios";

export default {
  name: "TpeSection",
  props: {
    tpeData: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      caisseBanque: [],
      loadingCaisses: true,
      requiredFields: ["caisseBank", "transactionId", "montant"],
      validationErrors: {},
    };
  },
  created() {
    this.fetchCaisses();
  },
  methods: {
    async fetchCaisses() {
      try {
        this.loadingCaisses = true;
        const res = await apiClient.get("/compV3/caisse/bank");
        this.caisseBanque = res.data;
        this.loadingCaisses = false;
      } catch (error) {
        this.$message.error(this.$t("caisse.erreurChargementCaisses"));
        this.loadingCaisses = false;
      }
    },
    emitTpeData(field, value) {
      this.$emit("update-tpe-data", field, value);
      this.validateField(field, value);
    },
    validateField(field, value) {
      if (this.requiredFields.includes(field)) {
        if (field === "montant") {
          if (!value || value <= 0) {
            this.$set(this.validationErrors, field, true);
          } else {
            this.$set(this.validationErrors, field, false);
          }
        } else {
          if (!value) {
            this.$set(this.validationErrors, field, true);
          } else {
            this.$set(this.validationErrors, field, false);
          }
        }
      }
    },
    isFieldInvalid(field) {
      return this.validationErrors[field] || false;
    },
    validateTpeData() {
      const errors = {};
      this.requiredFields.forEach((field) => {
        if (field === "montant") {
          if (!this.tpeData[field] || this.tpeData[field] <= 0) {
            errors[field] = true;
          }
        } else {
          if (!this.tpeData[field]) {
            errors[field] = true;
          }
        }
      });
      this.validationErrors = errors;
      return Object.keys(errors).length === 0;
    },
  },
};
</script>

<style scoped>
.tpe-section {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 16px 24px;
  margin-bottom: 16px;
  width: 100%;
}
.tpe-divider {
  margin-bottom: 16px;
}
.divider-text {
  font-weight: 600;
  color: #1890ff;
  font-size: 16px;
}
.tpe-fields-row {
  display: flex;
  gap: 12px;
  margin-top: 12px;
}
.tpe-field {
  flex: 1;
}

.input-error {
  border: 1px solid #ff4d4f !important;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2) !important;
}
</style>
